module.exports = __webpack_public_path__ + "media/common/images/badges/active/sprinter-172977020e7b95677a3d0da69d8aa501.svg";